  <template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="setting">
            <h3 class="subTitle">계정설정</h3>
          <template v-if="IS_LOGIN">
            <div class="context">
              <div class="article withAuthorized">
               <p>{{this.userName}}님 환영합니다.</p>
                  <button type="button"  class="authorized" @click="logOutAction">로그아웃</button>
              </div>
              <div class="article arrow" @click="warpChangeInfo">
               <p>회원정보 변경</p>
                <span class="imgWrap" ><img src="../../assets/images/enter.png"></span>
              </div>
              <div class="article arrow" @click="warpChangePw">
                <p>비밀번호 변경</p>
                <span class="imgWrap" ><img src="../../assets/images/enter.png"></span>
              </div>
              <div class="control" v-if="mobileInfo.info">
                <div class="item">
                  <div class="content">
                    <h3 class="subTitle">푸쉬알림설정</h3>
                    <p>공지사항, 검사결과등 고객을 위한</p>
                    <p>혜택을 알려드립니다.</p>
                  </div>
                  <div class="switch_wrap default">
                    <label class="switch">
                      <input type="checkbox" @click="receivePush()" v-model="checked">
                      <span class="slider round"></span>
                    </label>
                  </div>
                </div>
                <div class="item">
                  <div class="content">
                    <div class="contentWrap">
                      <h3 class="subTitle version">현재버전 {{version}}</h3>
                      <button type="button" @click="goStore()" v-if="mobileInfo.update">업데이트</button>
                    </div>
                    <p v-if="!mobileInfo.update">최신버전입니다.</p>
                    <div class="updateBtn" v-else>
                      <p>최신버전: {{mobileInfo.version}} </p>
                      <div class="btnInfo">
                        <p>업데이트 버전이 있습니다.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="control" v-if="mobileInfo.info">
                <div class="item">
                  <div class="content">
                    <h3 class="subTitle" @click="goLicenses()">오픈소스 라이선스</h3>
                  </div>
                </div>
              </div>
              <h6 class="secession" :class="{blank: !mobileInfo.info}">
                <router-link to="/modifyUser/confirmPasswordSecession">회원탈퇴</router-link>
              </h6>
            </div>
          </template>
          <template v-else>
            <div class="context">
              <div class="article withAuthorized">
                <p>계정정보가 없습니다.</p>
                <button type="button"  class="authorized" @click="logIn">로그인</button>
              </div>
              <div class="control" v-if="mobileInfo.info">
                <div class="item">
                  <div class="content">
                    <div class="contentWrap">
                      <h3 class="subTitle version">현재버전 {{version}}</h3>
                      <button type="button" @click="goStore()" v-if="mobileInfo.update">업데이트</button>
                    </div>
                    <p v-if="!mobileInfo.update">최신버전입니다.</p>
                    <div class="updateBtn" v-else>
                      <p>최신버전: {{mobileInfo.version}} </p>
                      <div class="btnInfo">
                        <p>업데이트 버전이 있습니다.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="control" v-if="mobileInfo.info">
                <div class="item">
                  <div class="content">
                    <h3 class="subTitle" @click="goLicenses()">오픈소스 라이선스</h3>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="bottomImg">
            <img src="@/assets/images/logo_grey.svg">
          </div>
        </div>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '../../components/AppHeader'
import AppSidebar from '../../components/AppSidebar'
import AddPopup from '../../components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'
import { getCookie } from '../../utils/cookieNew'
import router from '../../router'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        nextLink: '',
        closeType: 'close'
      },
      transDate: {
        headerName: '설정',
        prevUrl: '/'
      },
      userName: '',
      checked: true,
      os: '',
      version: '',
      mobileInfo: {
        info: false,
        check: false,
        os: '',
        version: '',
        option: '',
        url: '',
        update: false
      },
      setCount: false
    }
  },
  created () {
    if (getCookie('userName') !== undefined) {
      this.userName = getCookie('userName')
    }
    if (sessionStorage.getItem('userAgent') !== 'pc') {
      if (getCookie('deviceId') !== undefined) {
        this.versionCheck()
      } else {
        console.log('모바일 환경에서 접근하면 문제가 있습니다.')
        console.log('deviceId', getCookie('deviceId'))
        console.log('userAgent', sessionStorage.getItem('userAgent'))
      }
      if (getCookie('token') !== undefined) {
        this.fetchData()
      }
    }
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  computed: {
    ...mapState([
      'checkPopup'
    ]),
    deviceId () {
      return this.$store.state.device.deviceId
    },
    token () {
      return this.$store.state.userData.token
    },
    ...mapGetters([
      'GET_PUSH_CHECK',
      'IS_LOGIN',
      'getVersion'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapActions([
      'LOGOUT_USER',
      'TRANS_IS_RECEIVEPUSH',
      'PUSH_CHECK'
    ]),
    ...mapActions([
      'VERSION_CHECK'
    ]),
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    },
    goLicenses () {
      if (getCookie('device') !== undefined) {
        const os = getCookie('device')
        if (os === 'A') {
          location.href = '/licenses_android'
        } else if (os === 'I') {
          location.href = '/licenses_ios'
        }
      }
    },
    goStore () {
      location.href = this.mobileInfo.url
    },
    async versionCheck () {
      console.log('getCookie(device): ', getCookie('device'))
      this.mobileInfo.info = true
      console.log('모바일 진입')
      console.log('os: ' + getCookie('device'))
      console.log('version: ' + getCookie('appVersion'))
      this.os = getCookie('device')
      this.version = getCookie('appVersion')
      if (this.os === 'A') {
        this.os = 'Android'
      } else if (this.os === 'I') {
        this.os = 'iOS'
      }
      const payload = {
        os: this.os,
        version: this.version
      }
      console.log('payload: ', payload)
      console.log('payload.os: ', payload.os)
      console.log('payload.version: ', payload.version)
      try {
        await this.VERSION_CHECK(payload)
          .then(() => {
            this.mobileInfo.check = this.getVersion.check
            this.mobileInfo.os = this.getVersion.os
            this.mobileInfo.version = this.getVersion.version
            this.mobileInfo.option = this.getVersion.option
            this.mobileInfo.url = this.getVersion.url

            console.log('check:', this.mobileInfo.check)
            console.log('os:', this.mobileInfo.os)
            console.log('version:', this.mobileInfo.version)
            console.log('option:', this.mobileInfo.option)
            console.log('url:', this.mobileInfo.url)
            /* check = false면 최신버전이 아님 */
            if (this.mobileInfo.check === false) {
              this.mobileInfo.update = true // 업데이트 버전 있음
            } else {
              this.mobileInfo.update = false // 업데이트 버전 없음
            }
            // if (this.mobileInfo.option === 1) {
            //   this.SET_POPUP(true)
            //   this.popupSet.count = 'mobileAction'
            //   this.popupSet.closeType = 'close'
            //   this.popupSet.content = '업데이트 버전이 있습니다. 확인을 누르면 업데이트 하실 수 있습니다.'
            //   this.popupSet.mobileLink = this.mobileInfo.url
            // }
            // if (this.mobileInfo.option === 2) {
            //   this.SET_POPUP(true)
            //   this.popupSet.count = 'mobileAction'
            //   this.popupSet.closeType = 'mobileAction'
            //   this.popupSet.content = '최신 버전으로 업데이트 후 앱 사용이 가능합니다.'
            //   this.popupSet.mobileLink = this.mobileInfo.url
            // }
          })
      } catch (error) {
        this.SET_POPUP(true)
        this.popupSet.content = errorParser.parse(error)
      } finally {
      }
    },
    async fetchData () {
      try {
        await this.PUSH_CHECK()
          .then(() => {
            this.carryData()
          })
      } catch (error) {
        console.log('error :', error);
        console.log('알림 체크 API에서 에러납니다.')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      } finally {
      }
    },
    carryData () {
      this.checked = this.GET_PUSH_CHECK
      console.log('현재 푸쉬허용여부: ', this.checked)
    },
    async logOutAction () {
      if (sessionStorage.getItem('userAgent') === 'mobile') {
      }
      try {
        await this.LOGOUT_USER()
          .then(() => {
            this.popupSetter()
          })
      } catch (error) {
        console.log('error :', error);
        console.log('설정- 로그아웃 API 에러')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      } finally {
      }
    },
    popupSetter () {
      this.SET_POPUP(true)
      this.popupSet.content = '로그아웃 되었습니다.'
      this.popupSet.closeType = 'action'
      this.popupSet.closeLink = '/'
      this.popupSet.count = 'another'
      this.popupSet.nextLink = '/'
    },
    logIn () {
      router.push('/logIn')
    },
    warpChangePw () {
      router.push('/modifyUser/confirmPassword')
    },
    warpChangeInfo () {
      router.push('/modifyUser/confirmPasswordInfo')
      /* this.$store.commit('SET_CHANGE_TYPE', false) */
    },
    async receivePush () {
      this.checked = !this.checked
      console.log('Request params에 보낼 boolean', this.checked)
      try {
        const userData = {
          push: this.checked
        }
        console.log('보내는데이터', userData)
        await this.TRANS_IS_RECEIVEPUSH(userData)
      } catch (error) {
        console.log('error :', error);
        console.log('푸시 읽힘 API 에서 에러남')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    }
  },
  beforeDestroy () {
    this.SET_POPUP(false)
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>
</style>
